import { RECORDING_INDEX_STORAGE_KEY, RECORDINGS_FRAGMENT_STORAGE_KEY } from './constants';
import type { PartialRecording } from '../../types';

export const getStoredRecordingsFragment = (): {
  recordingsList: PartialRecording[];
  lowerBound: number;
  watchedRecordingsIdsList: number[];
} => {
  const recordingsFragment = sessionStorage.getItem(RECORDINGS_FRAGMENT_STORAGE_KEY);
  if (recordingsFragment) {
    return JSON.parse(recordingsFragment);
  }

  // We use whatever we have as a recording index as the lower bound to fetch from
  const storedIndex = localStorage.getItem(RECORDING_INDEX_STORAGE_KEY);
  if (storedIndex) localStorage.removeItem(RECORDING_INDEX_STORAGE_KEY);

  const fragment = {
    recordingsList: [],
    lowerBound: storedIndex ? Number(storedIndex) : 0,
    watchedRecordingsIdsList: [],
  };
  sessionStorage.setItem(RECORDINGS_FRAGMENT_STORAGE_KEY, JSON.stringify(fragment));

  return fragment;
};
